import clsx from 'clsx';
import React from 'react';

interface SeatProgessProps {
  availableSeats: number;
  className: string;
  totalSeats: number;
  widthPercentage: number;
}

const SeatProgess = ({
  availableSeats,
  className,
  totalSeats,
  widthPercentage,
}: SeatProgessProps) => {
  const assignedSeats = totalSeats - availableSeats;
  const assignedPercentage = (assignedSeats / totalSeats) * 100;

  return (
    <div style={{ width: `${widthPercentage}%`, minWidth: '100px' }}>
      <span className="whitespace-nowrap font-suisse-intl text-body-sm font-light text-black">
        Assigned: {assignedSeats} / {totalSeats}
      </span>
      <div className="h-28 overflow-hidden rounded-20 border border-solid border-black">
        <div
          className={clsx(
            'h-full rounded-20 transition-[width] duration-500 ease-in-out',
            className
          )}
          style={{ width: `${assignedPercentage}%` }}
        />
      </div>
    </div>
  );
};

export default SeatProgess;
